export const CURRENT_ENV = process.env.NEXT_PUBLIC_DEPLOYMENT_ENVIRONMENT;
export type EnvType = 'DEV' | 'QA' | 'UAT' | 'PROD';

const env = (CURRENT_ENV?.toUpperCase() || 'DEV') as EnvType;

const envPrefixMap = {
  DEV: 'd79eef3bde0445518e995ef57333cd0d_',
  QA: '93aadb18021a441ba7c99eb365b6f7a1_',
  UAT: '28afc672302a4fae8b3988f7f7225dc1_',
  PROD: '',
};

const envPrefix = envPrefixMap[env];

export const IS_STAGING = process.env.NEXT_PUBLIC_IS_STAGING === 'true';
export const STAGING_PREFIX = IS_STAGING ? '28afc672302a4fae8b3988f7f7225dc1_' : '';
export const HCI_PARAMS = process.env.HCI_BUILDER_CONFIG_VALUE;
export const GLOBAL_MARKETING_BANNER_ID = `${envPrefix}ed98d54f6d374e0ab850b39749a1d8cf`;

export const POC_TOKENS = {
  INTERNAL_WEBHOOK_AUTH_TOKEN: 'YnVpbGRlcndlYmhvb2toYWhheW91',
  BUILDER_WEBHOOK_SECRET: 'Z1VCX9ZIUKStE9tbaXsJzw',
};
// This model ID is used to identify and exclude specific content from having
// its URL modified, as this model (Core) points to non-HCI subdomains.
export const CORE_MODEL_ID = '47f306d8d277478b9458f1e3cc309673';
